<template>
  <div>
    <div class="ui three column grid">
      <div class="column"></div>
      <div class="column">
        <div class="centered-header">
          <h2 class="ui header" style="color: #092442;">
            <i class="calendar alternate outline icon"></i>
            <div class="content">
              {{ `Visit # ${index}` }}
            </div>
          </h2>
        </div>
      </div>
      <div class="column">
        <button
          class="ui icon right floated red mini button"
          @click="remove()"
          v-if="index > 0"
        >
          <i class="close large icon"></i>
        </button>
      </div>
    </div>
    <div class="ui grid">
      <div class="row">
        <div class="twelve wide column">
          <div class="ui form" :id="id">
            <div class="fields">
              <div class="required field" style="width: 35%;">
                <label for="time">Time</label>
                <div
                  style="text-align: center"
                  class="ui calendar"
                  :id="timeInputId"
                >
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input
                      type="text"
                      placeholder="time"
                      readonly=""
                      name="time"
                    />
                  </div>
                </div>
              </div>
              <div class="field" style="width: 65%; margin-top: 25px;">
                <div
                  class="ui three column centered grid"
                  v-if="componentVisit && componentVisit.packages"
                >
                  <div
                    class="column"
                    v-for="(selectedPackage, index) in componentVisit.packages"
                    :key="selectedPackage.id"
                  >
                    <table class="ui center aligned celled teal table">
                      <thead>
                        <tr>
                          <th>
                            {{ getPackageName(selectedPackage) }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div class="ui fluid transparent input">
                              <input
                                type="number"
                                style="text-align: center"
                                :placeholder="'Quantity'"
                                v-model.number="selectedPackage.quantity"
                                :name="defaultInputName + index"
                                min="0"
                                step="1"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="four wide column" v-if="reminders">
          <table
            class="ui center definition aligned celled very compact fluid table"
            style="margin-top: 25px;"
          >
            <thead>
              <tr>
                <th></th>
                <th>Allowed To Use</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="selectedPackage in reminders"
                :key="selectedPackage.id"
                class="center aligned"
              >
                <td>
                  {{ getPackageName(selectedPackage) }}
                </td>
                <td>
                  {{ reminders[selectedPackage.id].quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="centered row">
        <div class="ui error message" v-if="showError && setErrors().length">
          <ul class="list">
            <li v-for="(error, index) in setErrors()" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quantitiesReminders: { type: Object, required: true },
    id: { type: Number, required: true },
    index: { type: Number, required: true },
    visit: { type: Object, required: true },
    showError: { type: Boolean, default: false }
  },
  data() {
    return {
      defaultInputName: 'quantity',
      componentVisit: undefined,
      timeInputId: `time${this.index}`,
      reminders: {}
    };
  },
  watch: {
    componentVisit: {
      handler: function() {
        this.fireVisitEvent();
      },
      deep: true
    },
    quantitiesReminders: {
      handler: function() {
        this.reminders = window._.cloneDeep(this.quantitiesReminders)
      },
      deep: true
    }
  },
  mounted() {
    this.componentVisit = { ...this.visit };
    this.reminders = window._.cloneDeep(this.quantitiesReminders)
    this.initGUI();
  },
  methods: {
    getPackageName(selectedPackage) {
      let quantity = selectedPackage.units ? selectedPackage.units : selectedPackage.quantity
      let packageName = selectedPackage.name + ' :: ' + selectedPackage.unit_price + ' × ' 
        + quantity

      if (selectedPackage.entities && selectedPackage.entities[0]) {
        packageName = selectedPackage.entities[0].name + ' :: ' + packageName
      }

      return packageName
    },
    initGUI() {
      this.$nextTick(() => {
        $(`#time${this.index}`).calendar({
          type: 'datetime',
          inline: true,
          onChange: (date, text, mode) => {
            this.componentVisit.time = date.toISOString();
            this.fireVisitEvent();
          }
        });

        $(`#time${this.index}`).calendar(
          'set date',
          new Date(this.componentVisit.time)
        );
      });
    },
    isValidQuantities() {
      for (const p of this.componentVisit.packages) {
        if (p.quantity && p.quantity > 0) {
          return true;
        }
      }
      return false;
    },
    fireVisitEvent() {
      this.$emit('package-visit', {
        data: {
          visit: this.componentVisit,
          index: this.index,
          validData: !!this.visit.time && this.isValidQuantities()
        }
      });
    },
    remove() {
      this.$emit('visit-remove');
    },
    setErrors() {
      let errors = [];
      if (!this.visit.time) {
        errors.push('Please, Choose a valid time for this visit');
      }
      if (!this.isValidQuantities()) {
        errors.push(
          'Please, at least one package must have a positive quantity'
        );
      }
      return errors;
    }
  }
};
</script>

<style>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/packages-visits-components/NewVisit.vue